import { IComparatorResponse } from '../../apps/comparator/models';

export const fetchComparatorDataMock: IComparatorResponse = {
  products: [
    {
      variantId: '1363417',
      name: "Cuchillo universal 8''",
      brand: 'tramontina',
      mediaUrls: [
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X/public',
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_01/public',
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_02/public',
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_21/public',
      ],
      rating: 0,
      reviews: 0,
      availability: {
        homeDelivery: true,
        clickAndCollect: true,
      },
      prices: [
        {
          label: 'CMR',
          type: 'CMR',
          symbol: 'S/',
          price: '6.90',
          unit: '',
          priceWithoutFormatting: 9.9,
        },
        {
          label: 'Normal',
          type: 'NORMAL',
          symbol: 'S/',
          price: '9.90',
          unit: '',
          priceWithoutFormatting: 9.9,
        },
      ],
      comparableAttributes: {
        Largo_de_punta_hasta_el_mango: {
          values: ['8'],
          name: 'Largo de punta hasta el mango',
        },
        Color: {
          values: ['Negro'],
          name: 'Color',
        },
        Material: {
          values: ['plastico'],
          name: 'Material',
        },
        Durabilidad: {
          values: ['3 años'],
          name: 'Durabilidad',
        },
      },
    },
    {
      variantId: '1339249',
      name: "Cuchillo de cocina 6''",
      brand: 'tramontina',
      mediaUrls: [
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_02/public',
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_21/public',
      ],
      rating: 0,
      reviews: 0,
      availability: {
        homeDelivery: true,
        clickAndCollect: true,
      },
      prices: [
        {
          label: 'Normal',
          type: 'NORMAL',
          symbol: 'S/',
          price: '9.90',
          unit: '',
          priceWithoutFormatting: 9.9,
        },
      ],
      comparableAttributes: {
        Largo_de_punta_hasta_el_mango: {
          values: ['-'],
          name: 'Largo de punta hasta el mango',
        },
        Color: {
          values: ['Marrón'],
          name: 'Color',
        },
        Material: {
          values: ['plastico'],
          name: 'Material',
        },
        Durabilidad: {
          values: ['3 años'],
          name: 'Durabilidad',
        },
      },
    },
    {
      variantId: '1339257',
      name: "Cuchillo de cocina 8''",
      brand: 'tramontina',
      mediaUrls: [
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/3295354/public',
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_02/public',
        'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/330003X_21/public',
      ],
      rating: 0,
      reviews: 0,
      availability: {
        homeDelivery: true,
        clickAndCollect: true,
      },
      prices: [
        {
          label: 'Normal',
          type: 'NORMAL',
          symbol: 'S/',
          price: '11.90',
          unit: '',
          priceWithoutFormatting: 11.9,
        },
      ],
      comparableAttributes: {
        Largo_de_punta_hasta_el_mango: {
          values: ['-'],
          name: 'Largo de punta hasta el mango',
        },
        Color: {
          values: ['Marrón'],
          name: 'Color',
        },
        Material: {
          values: ['plastico'],
          name: 'Material',
        },
        Durabilidad: {
          values: ['3 años'],
          name: 'Durabilidad',
        },
      },
    },
    {
      variantId: '100560',
      name: "Cuchillo de cocina 5''",
      brand: 'facusa',
      mediaUrls: ['https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/3365360/public'],
      rating: 0,
      reviews: 0,
      availability: {
        homeDelivery: true,
        clickAndCollect: true,
      },
      prices: [
        {
          label: 'Normal',
          type: 'NORMAL',
          symbol: 'S/',
          price: '7.90',
          unit: '',
          priceWithoutFormatting: 7.9,
        },
      ],
      comparableAttributes: {
        Largo_de_punta_hasta_el_mango: {
          values: ['-'],
          name: 'Largo de punta hasta el mango',
        },
        Color: {
          values: ['Marrón'],
          name: 'Color',
        },
        Material: {
          values: ['plastico'],
          name: 'Material',
        },
        Durabilidad: {
          values: ['3 años'],
          name: 'Durabilidad',
        },
      },
    },
    {
      variantId: '100609',
      name: "Cuchillo para pan 7''",
      brand: 'facusa',
      mediaUrls: ['https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/3299988/public'],
      rating: 0,
      reviews: 0,
      availability: {
        homeDelivery: true,
        clickAndCollect: true,
      },
      prices: [
        {
          label: 'CMR',
          type: 'CMR',
          symbol: 'S/',
          price: '5.90',
          unit: '',
          priceWithoutFormatting: 9.9,
        },
        {
          label: '',
          type: 'NORMAL',
          symbol: 'S/',
          price: '9.90',
          unit: '',
          priceWithoutFormatting: 9.9,
        },
      ],
      comparableAttributes: {
        Largo_de_punta_hasta_el_mango: {
          values: ['-'],
          name: 'Largo de punta hasta el mango',
        },
        Color: {
          values: ['Marrón'],
          name: 'Color',
        },
        Material: {
          values: ['plastico'],
          name: 'Material',
        },
        Durabilidad: {
          values: ['3 años'],
          name: 'Durabilidad',
        },
      },
    },
    {
      variantId: '1363409',
      name: "Cuchillo universal 6''",
      brand: 'tramontina',
      mediaUrls: ['https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/sodimacAR/3299996/public'],
      rating: 0,
      reviews: 0,
      availability: {
        homeDelivery: true,
        clickAndCollect: true,
      },
      prices: [
        {
          label: '',
          type: 'NORMAL',
          symbol: 'S/',
          price: '9.90',
          unit: '',
          priceWithoutFormatting: 9.9,
        },
      ],
      comparableAttributes: {
        Largo_de_punta_hasta_el_mango: {
          values: ['-'],
          name: 'Largo de punta hasta el mango',
        },
        Color: {
          values: ['Negro'],
          name: 'Color',
        },
        Material: {
          values: ['plastico'],
          name: 'Material',
        },
        Durabilidad: {
          values: ['3 años'],
          name: 'Durabilidad',
        },
      },
    },
  ],
  carouselName: 'Compare your product',
  meta: {
    productAttributes: ['Largo de punta hasta el mango', 'Color', 'Material', 'Durabilidad'],
  },
};
